module.exports = __webpack_public_path__ + "img/9788954644938.def02b50.jpg";